









































import { computed, UnwrapRef } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 页面数据
      pageData = computed(
        () => this.goodsData.value.marketingData.commodityBrand,
      )

      // 背景色
      bgColor = computed(() => this.pageData.value.backgroundColor)

      // 主题色
      color = computed(() => this.pageData.value.topicColor)

      // 模块列表
      list = computed<
        Array<{
          type: 'image' | 'button' | 'video'
          url: string
          text?: string
          full?: boolean
        }>
      >(() => [
        {
          type: 'image',
          url: this.pageData.value.mainImage,
          full: true,
        },
        ...(this.pageData.value.story.map(item => ({
          type: this.pageData.value.storyType === 0 ? 'image' : 'video',
          url: item,
        })) as any),
        {
          type: 'button',
          text: this.pageData.value.buttonText,
          url: this.pageData.value.targetUrl,
        },
        ...this.pageData.value.commodityDetails.map(item => ({
          type: 'image',
          url: item,
        })),
      ])

      // 点击按钮
      // eslint-disable-next-line no-undef
      handleButtonClick = (item: UnwrapRef<(typeof this)['list']>[0]) => {
        dcb.navigateTo({
          url: item.url,
        })
      }
    },
)
